/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { RESPONSEMESSAGE } from '@/utils/constants';
import { ApiStatusResponseType } from '@/types/Profile/ApiStatusResponseType';

export interface IResponseMessageState {
  messages: ApiStatusResponseType;
}

const initialState: IResponseMessageState = {
  messages: {} as ApiStatusResponseType,
};

export const responseMessageSlice = createSlice({
  name: RESPONSEMESSAGE,
  initialState,
  reducers: {
    setResponseMessage: (
      state,
      { payload }: PayloadAction<ApiStatusResponseType>
    ) => {
      state.messages = payload;
    },
  },
});

export const { setResponseMessage } = responseMessageSlice.actions;

export const responseMessageReducer = responseMessageSlice.reducer;
